import ModalLogin, { modalVisibility } from '@client/ClientEvents/Common/Modal.jsx';

export {modalVisibility};
export default ModalLogin;